import React, { useEffect } from 'react';
import { Toaster } from 'sonner';
import SEOHead from '../components/SEOHead';
import HeroSection from '../components/landing/HeroSection';
import ProblemSection from '../components/landing/ProblemSection';
import SolutionSection from '../components/landing/SolutionSection';
import BenefitsSection from '../components/landing/BenefitsSection';
import AuthoritySection from '../components/landing/AuthoritySection';
import PlansSection from '../components/landing/PlansSection';
import ContactFormSection from '../components/landing/ContactFormSection';
import FAQSection from '../components/landing/FAQSection';
import CTASection from '../components/landing/CTASection';
import Header from '../components/landing/Header';
import Footer from '../components/landing/Footer';
import WhatsAppButton from '../components/landing/WhatsAppButton';

const LandingPage = () => {
  useEffect(() => {
    // Google Analytics Placeholder
    window.dataLayer = window.dataLayer || [];
    function gtag(){window.dataLayer.push(arguments);}
    gtag('js', new Date());
    // Add your GA4 ID here later
    // gtag('config', 'G-XXXXXXXXXX');
  }, []);

  return (
    <>
      <SEOHead />
      <div className="landing-page bg-white">
        <Toaster position="top-center" richColors />
        <Header />
        <HeroSection />
        <ProblemSection />
        <SolutionSection />
        <BenefitsSection />
        <AuthoritySection />
        <PlansSection />
        <ContactFormSection />
        <FAQSection />
        <CTASection />
        <Footer />
        <WhatsAppButton />
      </div>
    </>
  );
};

export default LandingPage;
